import { render, staticRenderFns } from "./EditIns.vue?vue&type=template&id=a8981a44&scoped=true&"
import script from "./EditIns.vue?vue&type=script&lang=js&"
export * from "./EditIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8981a44",
  null
  
)

export default component.exports